import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
// Angular
import { RouterModule } from '@angular/router';
// NgBootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// SVG inline
// Perfect Scrollbar
import { LayoutUtilsService } from '../../core/_base/crud';
// Core module
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { ActionNotificationComponent } from './content/crud/action-natification/action-notification.component';
// CRUD Partials
import { FullWelcomeDialogComponent } from './content/full-welcome-dialog/full-welcome.dialog.component';
// General
import { HalfWelcomeDialogComponent } from './content/half-welcome-dialog/half-welcome.dialog.component';
import { LoginDialogComponent } from './content/login/login.dialog.component';
import { LanguageSelectorComponent } from './layout/language-selector/language-selector.component';
// Layout partials
import { MiniAppTabBarComponent } from './layout/mini-app-tab-bar/mini-app-tab-bar.component';
import { SplashScreenComponent } from './layout/splash-screen/splash-screen.component';
import { FeedbackFormDialogComponent } from './content/feedback-form/feedback-form.dialog.component';

@NgModule({
  declarations: [
    SplashScreenComponent,
    MiniAppTabBarComponent,
    HalfWelcomeDialogComponent,
    FullWelcomeDialogComponent,
    ActionNotificationComponent,
    LoginDialogComponent,
    LanguageSelectorComponent,
    FeedbackFormDialogComponent
  ],
  exports: [
    MatDialogModule,
    ActionNotificationComponent,
    SplashScreenComponent,
    MiniAppTabBarComponent,
    HalfWelcomeDialogComponent,
    FullWelcomeDialogComponent,
    LoginDialogComponent,
    LanguageSelectorComponent,
    FeedbackFormDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CoreModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatIconModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    MatDialogModule,
    SharedModule,
    MatDialogModule
  ],
  providers: [
    LayoutUtilsService,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: true,
        panelClass: 'app-mat-dialog-container__wrapper',
        height: 'auto',
        width: '80%'
      }
    }
  ],
  // entryComponents: [
  //   ActionNotificationComponent
  // ]
})
export class PartialsModule {
}
